import React from 'react';

import { RightSidebar } from "../../../_partials/Layout";

const _SidebarShow = () => {
  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />
    </RightSidebar>
  )
}

export default _SidebarShow;
